module.exports = __webpack_public_path__ + "static/SimeonC-cf824d18fa933545c17f52263e4d1a8e.gif";